import { Injectable } from '@angular/core';
import
    { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthService } from '../services/auth/auth.service';
import { RoutesService } from '../services/routes/routes.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard 
{

    constructor(
        private authService: AuthService,
        private router: Router,
        private routesService: RoutesService
    )
    {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
        return this.authService.loginState.pipe(
            tap(_state =>
            {
                if (!_state)
                {
                    console.log("🚀 ~ file: auth.guard.ts:41 ~ route:", route);
                    this.routesService.saveRoute('sign-in-redirect', state.url);
                    this.router.navigate([ '/sign-in' ], { queryParams: route.queryParams, queryParamsHandling: 'merge' });
                }
            })
        );
    }
    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
        return this.canActivate(childRoute, state);
    }

}
